let showLoaderFn = null;
let hideLoaderFn = null;

export const registerLoader = (show, hide) => {
    showLoaderFn = show;
    hideLoaderFn = hide;
};

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const withLoader = async (promise) => {
    try {
        showLoaderFn?.();

        // await sleep(800);

        return await promise;
    } finally {
        hideLoaderFn?.();
    }
};
